import Vue from 'vue';
import { range } from '@/helpers';
const namespaced = true;
export default {
  namespaced,
  mutations: {
    toggleTag({ selectedTags }, value) {
      if (selectedTags[value]) {
        Vue.delete(selectedTags, value);
      } else {
        Vue.set(selectedTags, value, true);
      }
    },
    selectSource({ selectedSourceIds }, value) {
      if (selectedSourceIds[value]) {
        Vue.delete(selectedSourceIds, value);
      } else {
        Vue.set(selectedSourceIds, value, true);
      }
    },
    resetDuration(state) {
      state.duration = state.default_duration;
    },
    resetAge(state) {
      state.age = state.default_age;
    },
    resetSentiment(state) {
      state.sentiment = state.default_sentiment;
    },
    resetSource(state) {
      state.selectedSourceIds = {};
      state.sourcePopularity = state.default_sourcePopularity;
    },
    resetEngagement(state) {
      state.interestingness = state.default_interestingness;
      state.visuality = state.default_visuality;
    },
    resetVolume(state) {
      state.volume = state.default_volume;
    },
    updateTags(state, value = []) {
      const { tags } = state;
      Object.entries(tags || {}).forEach(([tag]) => (tags[tag] = 0));
      value.forEach(({ value, count }) => value in tags && (tags[value] = count));
    },
    updateSourceIds(state, value = []) {
      const map = value.reduce((all, { info: { id }, count }) => ({ ...all, [id]: count }), {});
      const { sourceIds } = state;
      sourceIds.forEach(source => (source.count = map[source.info.id] || 0));
      sourceIds.forEach(source => {
        source.count = map[source.info.id] || 0;
      });
      // value.forEach(({ value, count }) => value in sourceIds && (sources[value] = count));
    }
  },
  actions: {
    async toggleTag({ commit, dispatch }, value) {
      commit('toggleTag', value);
      dispatch('fetchMedia');
    },
    async selectSource({ commit, dispatch }, value) {
      commit('selectSource', value);
      dispatch('fetchMedia');
    },
    async resetDuration({ commit, dispatch }) {
      commit('resetDuration');
      dispatch('fetchMedia');
    },
    async resetAge({ commit, dispatch }) {
      commit('resetAge');
      dispatch('fetchMedia');
    },
    async resetSentiment({ commit, dispatch }) {
      commit('resetSentiment');
      dispatch('fetchMedia');
    },
    async resetVolume({ commit }) {
      commit('resetVolume');
    },
    async resetEngagement({ commit, dispatch }) {
      commit('resetEngagement');
      dispatch('fetchMedia');
    },
    async resetSource({ commit, dispatch }) {
      commit('resetSource');
      dispatch('fetchMedia');
    },
    async duration(
      {
        commit,
        dispatch,
        getters: { duration, default_duration }
      },
      [min, max]
    ) {
      if (!default_duration) {
        commit('default_duration', duration);
      }
      if (min === max) {
        if (max === 50) {
          min -= 10;
        } else {
          max += 10;
        }
      }
      commit('duration', [min, max]);
      if (default_duration) {
        await dispatch('fetchMedia');
      }
    },
    async age(
      {
        commit,
        dispatch,
        getters: { age, default_age }
      },
      [min, max]
    ) {
      if (!default_age) {
        commit('default_age', age);
      }
      if (min === max) {
        if (max === 5) {
          min -= 1;
        } else {
          max += 1;
        }
      }
      commit('age', [min, max]);
      if (default_age) {
        await dispatch('fetchMedia');
      }
    },
    async sentiment(
      {
        commit,
        dispatch,
        getters: { sentiment, default_sentiment }
      },
      [min, max]
    ) {
      if (!default_sentiment) {
        commit('default_sentiment', sentiment);
      }
      if (min === max) {
        if (max === 5) {
          min -= 1;
        } else {
          max += 1;
        }
      }
      commit('sentiment', [min, max]);
      if (default_sentiment) {
        await dispatch('fetchMedia');
      }
    },
    async interestingness(
      {
        commit,
        dispatch,
        getters: { interestingness, default_interestingness }
      },
      [min, max]
    ) {
      if (!default_interestingness) {
        commit('default_interestingness', interestingness);
      }
      if (min === max) {
        if (max === 5) {
          min -= 1;
        } else {
          max += 1;
        }
      }
      commit('interestingness', [min, max]);
      if (default_interestingness) {
        await dispatch('fetchMedia');
      }
    },
    async visuality(
      {
        commit,
        dispatch,
        getters: { visuality, default_visuality }
      },
      [min, max]
    ) {
      if (!default_visuality) {
        commit('default_visuality', visuality);
      }
      if (min === max) {
        if (max === 5) {
          min -= 1;
        } else {
          max += 1;
        }
      }
      commit('visuality', [min, max]);
      if (default_visuality) {
        await dispatch('fetchMedia');
      }
    },
    async volume(
      {
        commit,
        getters: { volume, default_volume }
      },
      [min, max]
    ) {
      if (!default_volume) {
        commit('default_volume', volume);
      }
      if (min === max) {
        if (max === 5) {
          min -= 1;
        } else {
          max += 1;
        }
      }
      commit('volume', [min, max]);
      if (default_volume) {
        //await dispatch('fetchMedia');
      }
    },
    async sourcePopularity(
      {
        //state,
        commit,
        dispatch,
        getters: { sourcePopularity, default_sourcePopularity }
      },
      [min, max]
    ) {
      if (!default_sourcePopularity) {
        commit('default_sourcePopularity', sourcePopularity);
      }
      if (min === max) {
        if (max === 5) {
          min -= 1;
        } else {
          max += 1;
        }
      }
      commit('sourcePopularity', [min, max]);
      if (default_sourcePopularity) {
        await dispatch('fetchMedia');
      }
    },
    async selectedCategories(
      {
        commit,
        dispatch,
        getters: { selectedCategories }
      },
      value
    ) {
      if ((selectedCategories || []).join('|') !== (value || []).join('|')) {
        commit('selectedCategories', value);
        await dispatch('fetchMedia');
      }
    },
    async selectedSectors(
      {
        commit,
        dispatch,
        getters: { selectedSectors }
      },
      value
    ) {
      if ((selectedSectors || []).join('|') !== (value || []).join('|')) {
        commit('selectedSectors', value);
        await dispatch('fetchMedia');
      }
    },
    async selectedTypes(
      {
        commit,
        dispatch,
        getters: { selectedTypes }
      },
      value
    ) {
      if ((selectedTypes || []).join('|') !== (value || []).join('|')) {
        commit('selectedTypes', value);
        await dispatch('fetchMedia');
      }
    },
    updateSourceIds({ commit }, value) {
      commit('updateSourceIds', value);
    },
    updateTags({ commit }, value) {
      commit('updateTags', value);
    },
    async fetchMedia({ dispatch }, value) {
      return await dispatch('fetchMedia', value, { root: true });
    }
  },
  getters: {
    source(state, { selectedSourceIds }) {
      const modified = Object.keys(selectedSourceIds || {}).length;
      let r = [...state.sourcePopularity];
      if (modified) {
        r = r || [];
        r.push(modified);
      }
      return r;
    },
    default_source(state, { default_sourcePopularity }) {
      return default_sourcePopularity;
    },
    //engagement(state, { interestingness, visuality }) {
    engagement(state) {
      return [...(state.interestingness || []), ...(state.visuality || [])];
    },
    default_engagement(state, { default_interestingness, default_visuality }) {
      return [...(default_interestingness || []), ...(default_visuality || [])];
    },
    durationQuantiles(state, { duration = [] }) {
      const [min, max] = duration.map(v => v / 10 + 1);
      return range(min, max);
    },
    publishedAtQuantiles(state, { age = [] }) {
      const [min, max] = age.map(v => v + 1);
      return range(min, max);
    },
    sentimentQuantiles(state, { sentiment = [] }) {
      const [min, max] = sentiment.map(v => v + 1);
      return range(min, max);
    },
    interestingnessQuantiles(state, { interestingness = [] }) {
      const [min, max] = interestingness.map(v => v + 1);
      return range(min, max);
    },
    visualityQuantiles(state, { visuality = [] }) {
      const [min, max] = visuality.map(v => v + 1);
      return range(min, max);
    },
    volumeQuantiles(state, { volume = [] }) {
      const [min, max] = volume.map(v => v + 1);
      return range(min, max);
    },
    subscriberCountQuantiles(state, { sourcePopularity = [] }) {
      const [min, max] = sourcePopularity.map(v => v + 1);
      return range(min, max);
    },
    tags(state, g, rs, { collapse }) {
      const { tags } = state;
      return (
        (collapse &&
          Object.entries(tags || {})
            //.sort(([ka, a], [kb, b]) => b - a)
            .sort(([, a], [, b]) => b - a)
            .reduce((tags, [key, value]) => {
              return { ...tags, [key]: value };
            }, {})) ||
        tags
      );
    }
  }
};
